import { render, staticRenderFns } from "./SearchField.vue?vue&type=template&id=851a005a&scoped=true&"
import script from "./SearchField.vue?vue&type=script&lang=js&"
export * from "./SearchField.vue?vue&type=script&lang=js&"
import style0 from "./SearchField.vue?vue&type=style&index=0&id=851a005a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851a005a",
  null
  
)

/* custom blocks */
import block0 from "./SearchField.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports